/**
 * Order FAQ
 *
 * A couple of FAQs that can be displayed during checkout, to improve the confidence of the customer and improve the
 * order completion rate.
 */
export default function OrderFAQ({
  deposit_non_refundable = false,
}: {
  deposit_non_refundable?: boolean;
}) {
  return (
    <div className="mt-5">
      <h4>Order FAQs</h4>

      <div style={{ marginBottom: 0 }}>
        <strong>What happens if I need to cancel?</strong>
        {!deposit_non_refundable && (
          <p>
            On most trips, you can freely change dates or cancel your booking up
            to 60 days before departure. Deposits are non-refundable for cash.
            However, with our Lifetime Deposit Guarantee, you'll receive Skyhook
            credits on your account equivalent to the deposit you paid. Use this
            against the deposit of any future trip on Skyhook. Cancellations
            within 2 months of your trip are non-refundable.
          </p>
        )}

        {deposit_non_refundable && (
          <p>
            Please note that the deposit is non-refundable for this trip, as it
            is used to purchase non-refundable permits.
          </p>
        )}
      </div>

      <div>
        <strong>Is my payment protected?</strong>
        <p>
          Yes, your payment is protected by Trust My Travel (membership number
          TMT51612). In the very unlikely event that Skyhook or the Host needs
          to cancel your trip, you'll receive a full refund. This excludes
          cancellations due to unavoidable and extraordinary circumstances (for
          example, extreme weather events) that are beyond Skyhook's or the
          Host's control.
        </p>
      </div>

      <div>
        <strong>Is my trip guaranteed to run?</strong>
        <p>
          Our Hosts list their guaranteed group departure dates so you can book
          knowing your trip will go ahead. For the select few adventures that
          need a minimum number of people to run, you'll see an{' '}
          <strong>Important notice</strong> on the trip page.
        </p>
      </div>
    </div>
  );
}
